import { Route } from "react-router-dom";
import { lazy } from "react";
import ProtectedRoute from "../components/ProtectedRoute";

const OperatorInfo = lazy(() => import("../layouts/operator/OperatorInfo"));

export default function OperatorRoutes() {
  return (
    <>
      <Route
        path="/home/operator"
        element={
          <ProtectedRoute allowedRoles={["OPERARIO"]}>
            <OperatorInfo />
          </ProtectedRoute>
        }
      />
    </>
  );
}